module.exports = __webpack_public_path__ + "media/images/flags/aq-76bb0c16871d316993f20a13c02eea30.svg";